import ReactOnRails from 'react-on-rails/client';
import Delegates from '../../app/Delegates.jsx';

ReactOnRails.register({Delegates});